import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/users/password-reset/request`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        setEmail(''); // Clear the email field
      } else {
        setError(data.detail || 'Failed to send password reset email');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <Card>
            <Card.Body>
              <h2 className="text-center mb-4">Forgot Password</h2>

              {success ? (
                <Alert variant="success">
                  <Alert.Heading>Email Sent!</Alert.Heading>
                  <p>
                    If an account exists with that email, we've sent you a password reset link.
                    Please check your inbox and spam folder.
                  </p>
                  <hr />
                  <p className="mb-0">
                    The link will expire in 1 hour for security reasons.
                  </p>
                </Alert>
              ) : (
                <>
                  {error && <Alert variant="danger">{error}</Alert>}

                  <p className="text-muted mb-4">
                    Enter your email address and we'll send you a link to reset your password.
                  </p>

                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="email">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={loading}
                      />
                      <Form.Text className="text-muted">
                        We'll never share your email with anyone else.
                      </Form.Text>
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      disabled={loading}
                      className="w-100 mb-3"
                    >
                      {loading ? 'Sending...' : 'Send Reset Link'}
                    </Button>
                  </Form>
                </>
              )}

              <div className="text-center mt-3">
                <Link to="/login">Back to Login</Link>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
}

export default ForgotPassword;
